import { Box, Paper, Stack, Typography } from "@mui/material";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";

interface MdaEmptyStateProps {
  hasApplied: boolean;
  idleMessage?: string;
  noResultsMessage?: string;
}

const MdaEmptyState = ({
  hasApplied,
  idleMessage = "Apply filters above to view claims.",
  noResultsMessage = "No claims match the selected filters.",
}: MdaEmptyStateProps) => (
  <Paper
    elevation={0}
    sx={{
      minHeight: { xs: 300, sm: 430 },
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: "1px solid #dfe6f0",
      borderRadius: 1.5,
      backgroundColor: "#fff",
    }}
  >
    <Stack
      alignItems="center"
      spacing={1.25}
      sx={{ textAlign: "center", px: 2 }}
    >
      <Box
        sx={{
          width: 72,
          height: 72,
          display: "grid",
          placeItems: "center",
          border: "2px dashed #cbd7e8",
          borderRadius: 1.5,
          color: "#a7b8d1",
        }}
      >
        <TableChartOutlinedIcon sx={{ fontSize: 37 }} />
      </Box>
      <Typography
        sx={{ mt: 0.5, color: "#172841", fontWeight: 700, fontSize: "1.1rem" }}
      >
        No claims to display yet
      </Typography>
      <Typography sx={{ color: "#687890", fontSize: "0.9rem" }}>
        {hasApplied ? noResultsMessage : idleMessage}
      </Typography>
    </Stack>
  </Paper>
);

export default MdaEmptyState;
